'use client';

import { ScreenContainer } from '@/components/core';
import { UIComponent } from '@/components/core/components';
import { CategoryConstantType, CollectionType, ProductType, UserType } from '@/@types';
import { AnimateOnViewport } from '@/components/core/components/atoms';
import Hero from './_components/hero';
import RecommendationCard from './_components/recommendation-card';
import HomeMap from './_components/map';
import * as styles from './home.styles';
import Recommendations from './_components/recommendations';
import Monetization from './_components/monetizacion';
import Users from './_components/users';
import Brands from './_components/brands';
import Collections from './_components/collections';
import Ratings from './_components/ratings';
import Multiplatform from './_components/multiplatform';

const Home: UIComponent<{ category: CategoryConstantType; users: UserType[]; collections: CollectionType[]; products: ProductType[] }> = ({
  category,
  users,
  collections,
  products,
}) => {
  return (
    <ScreenContainer className={styles.root}>
      <Hero />
      <AnimateOnViewport type="left">
        <RecommendationCard />
      </AnimateOnViewport>
      <AnimateOnViewport type="right">
        <HomeMap />
      </AnimateOnViewport>
      <AnimateOnViewport type="grow">
        <Recommendations category={category} products={products} />
      </AnimateOnViewport>
      <AnimateOnViewport type="grow">
        <Monetization />
      </AnimateOnViewport>
      <AnimateOnViewport type="grow">
        <Multiplatform />
      </AnimateOnViewport>
      <AnimateOnViewport type="grow">
        <Users users={users} />
      </AnimateOnViewport>
      {collections.length > 0 && (
        <AnimateOnViewport type="grow">
          <Collections collections={collections} />
        </AnimateOnViewport>
      )}
      <AnimateOnViewport type="grow">
        <Ratings />
      </AnimateOnViewport>
      <AnimateOnViewport type="grow">
        <Brands />
      </AnimateOnViewport>
    </ScreenContainer>
  );
};

export default Home;
